var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dropdown-item',_vm._b({},'el-dropdown-item',_vm.$attrs,false),[_c('div',{class:['dropdown-item', _vm.font14 ? 'font14' : 'font12'],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }